// Local inline-SVG illustration for the /signup GSTIN screen. Pairs a
// blue verified shield with a "GSTIN" document and a small green tick
// badge — drawn entirely with SVG primitives so there are no external
// images, fonts, or icon-CDN dependencies. Sized via the wrapping
// element's width; the SVG itself uses viewBox-based scaling.

export default function ShieldDocIllustration({ className = '' }) {
  return (
    <svg
      viewBox="0 0 240 200"
      role="img"
      aria-label="GSTIN verified illustration"
      className={className}
    >
      <defs>
        <linearGradient id="shielddoc-shield" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#5E9DF9" />
          <stop offset="100%" stopColor="#1567D1" />
        </linearGradient>
        <linearGradient id="shielddoc-shield-face" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#86B6FB" />
          <stop offset="100%" stopColor="#1877F2" />
        </linearGradient>
        <linearGradient id="shielddoc-bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#EBF3FF" />
          <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* Soft halo behind the shield */}
      <circle cx="92" cy="100" r="78" fill="url(#shielddoc-bg)" />

      {/* Document */}
      <g transform="translate(140 36)">
        <rect
          x="0"
          y="0"
          width="80"
          height="104"
          rx="6"
          fill="#FFFFFF"
          stroke="#D6E6FE"
          strokeWidth="1.5"
        />
        <rect x="10" y="14" width="38" height="8" rx="2" fill="#0F172A" />
        <rect x="10" y="32" width="60" height="3" rx="1.5" fill="#CBD5E1" />
        <rect x="10" y="40" width="52" height="3" rx="1.5" fill="#CBD5E1" />
        <rect x="10" y="48" width="56" height="3" rx="1.5" fill="#CBD5E1" />
        <rect x="10" y="60" width="48" height="3" rx="1.5" fill="#CBD5E1" />
        <rect x="10" y="68" width="58" height="3" rx="1.5" fill="#CBD5E1" />
        <rect x="10" y="76" width="40" height="3" rx="1.5" fill="#CBD5E1" />
        {/* Green tick badge bottom-right of document */}
        <circle cx="68" cy="92" r="12" fill="#10B981" />
        <path
          d="M62 92 L66.5 96.5 L74 88.5"
          stroke="#FFFFFF"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>

      {/* Shield */}
      <g transform="translate(48 38)">
        <path
          d="M44 0 C68 8 86 12 86 12 L86 56 C86 88 64 108 44 116 C24 108 2 88 2 56 L2 12 C2 12 20 8 44 0 Z"
          fill="url(#shielddoc-shield)"
        />
        <path
          d="M44 8 C64 14 78 18 78 18 L78 56 C78 82 60 99 44 106 C28 99 10 82 10 56 L10 18 C10 18 24 14 44 8 Z"
          fill="url(#shielddoc-shield-face)"
        />
        <path
          d="M28 58 L40 70 L62 46"
          stroke="#FFFFFF"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>

      {/* Sparkle accents */}
      <g fill="#1877F2">
        <circle cx="22" cy="48" r="2.5" />
        <circle cx="220" cy="56" r="2.5" />
      </g>
      <g fill="#F59E0B">
        <circle cx="36" cy="158" r="2" />
      </g>
      <g fill="#EC4899">
        <circle cx="226" cy="168" r="2" />
        <circle cx="120" cy="22" r="1.6" />
      </g>
      {/* Plus sparkles */}
      <g
        stroke="#1877F2"
        strokeWidth="1.6"
        strokeLinecap="round"
        opacity="0.7"
      >
        <line x1="14" y1="84" x2="22" y2="84" />
        <line x1="18" y1="80" x2="18" y2="88" />
        <line x1="208" y1="100" x2="216" y2="100" />
        <line x1="212" y1="96" x2="212" y2="104" />
      </g>
    </svg>
  );
}
